import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {getNoData} from "../../items/index.js";
import {AJAX_OPTION} from "../../../../util/Ajax.js";
import Widget from "../widget.js";
import {getFrequentMemberItem} from "./item.js";
import u from "../../../../util/index.js";

export class FrequentMemberWidget extends Widget {

    async setup(props) {
        if(!Mutil.isFunc('FREQUENT_MEMBER_WIDGET')) return;
        return super.setup(props);
    }

    async getData() {
        let inputData = {
            GUBUN: 'COUNT',
            SEARCH_WEEK: '2',
            USER_ID: _USER_ID,
            RGSR_ID: _USER_ID,
            USE_INTT_ID: _USE_INTT_ID,
        }
        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData, AJAX_OPTION.ALLOW_EXECUTE)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");

        return {recordData: data[this.$props.RECORD]};
    }

    async render() {
        $(this.$target).html('')
        $(this.$target).drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('data'),
            callback: {
                item: getFrequentMemberItem,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();

        const $t = $(this.$target);
        $t.find('.widget-article-list').removeClass('dash-pending')
        $t.find('.dash-num-pending').remove()

    }

    setEvent() {
        const $w = $(this.$target).closest('.widget-frequent-member');
        $w.off('click').on('click', (e) => {
            const $eTarget = $(e.target);

            /*멤버 아이템 */
            if ($eTarget.closest('.js-member-item').length > 0) {
                const userId = $eTarget.closest('.js-member-item').attr('data-user-id');
                userId && Profile.drawProfilePopup(userId);
            }
        })
    }

}

